"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.units = void 0;
exports.units = [
    {
        names: [
            'drop',
            'drops',
            'dr.',
            'dr',
            'drs.',
            'drs',
            'gt.',
            'gt',
            'gts.',
            'gts',
            'gtt',
            'gtt.',
            'gtts',
            'gtts.',
        ],
        grams: 0.05,
    },
    {
        names: [
            'smidgen',
            'smidgens',
            'smdg.',
            'smdg',
            'smdgs.',
            'smdgs',
            'smi',
            'smi.',
            'smis.',
            'smis',
        ],
        grams: 0.18,
    },
    {
        names: ['pinch', 'pinches', 'pinchs', 'pn.', 'pn', 'pns.', 'pns'],
        grams: 0.36,
    },
    {
        names: ['dash', 'dashs', 'dashes', 'ds.', 'ds', 'dss.', 'dss'],
        grams: 0.72,
    },
    {
        names: [
            'saltspoon',
            'salt spoon',
            'saltspoons',
            'salt spoons',
            'scruple',
            'scruples',
            'ssp.',
            'ssp',
            'ssps.',
            'ssps',
        ],
        grams: 17.1,
    },
    {
        names: [
            'coffeespoon',
            'coffee spoon',
            'coffeespoons',
            'coffee spoons',
            'csp.',
            'csp',
            'csps.',
            'csps',
        ],
        grams: 2.1,
    },
    {
        names: [
            'fluid dram',
            'fluiddram',
            'fluid drams',
            'fluiddrams',
            'fl.dr.',
            'fldr',
            'fl.dr',
            'fldr.',
            'fl.drs.',
            'fldrs',
            'fl.drs',
        ],
        grams: 3.69,
    },
    {
        names: [
            'teaspoon',
            'tea spoon',
            'teaspoons',
            'tea spoons',
            'tsp.',
            'tsp',
            'tsps.',
            'tsps',
            't.',
            't',
            'ts.',
            'ts',
        ],
        grams: 4.92,
    },
    {
        names: [
            'dessertspoon',
            'dessert spoon',
            'dessertspoons',
            'dessert spoons',
            'dsp.',
            'dsp',
            'dsps.',
            'dsps',
            'dssp.',
            'dssp',
            'dssps.',
            'dssps',
            'dstspn.',
            'dstspn',
            'dstspns.',
            'dstspns',
        ],
        grams: 9.85,
    },
    {
        names: [
            'tablespoon',
            'table spoon',
            'tablespoons',
            'table spoons',
            'tbsp.',
            'tbsp',
            'tbsps.',
            'tbsps',
            'T.',
            'T',
            'Ts.',
            'Ts',
        ],
        grams: 14.78,
    },
    {
        names: [
            'fluid ounce',
            'fluidounce',
            'fluid ounces',
            'fluidounces',
            'fl.oz.',
            'floz',
            'fl.oz',
            'floz.',
            'fl.ozs.',
            'flozs',
            'fl.ozs',
            'flozs.',
            'oz.',
            'oz',
            'ozs.',
            'ozs',
            'ounce',
            'ounces',
        ],
        grams: 29.57,
    },
    {
        names: [
            'wineglass',
            'wine glass',
            'wineglasses',
            'wine glasses',
            'wgf.',
            'wgf',
            'wgfs.',
            'wgfs',
        ],
        grams: 59.14,
    },
    {
        names: [
            'gill',
            'gills',
            'teacup',
            'tea cup',
            'teacups',
            'tea cups',
            'tcf.',
            'tcf',
            'tcfs.',
            'tcfs',
        ],
        grams: 118.29,
    },
    { names: ['cup', 'cups', 'C.', 'C', 'c.', 'c', 'Cs.', 'Cs'], grams: 236.588 },
    { names: ['pint', 'pints', 'pt.', 'pt', 'pts.', 'pts'], grams: 473.176 },
    { names: ['quart', 'quarts', 'qt.', 'qt', 'qts.', 'qts'], grams: 946.353 },
    {
        names: ['gallon', 'gallons', 'gal.', 'gal', 'gals.', 'gals'],
        grams: 3785.41,
    },
    { names: ['pound', 'pounds', 'lb.', 'lb', 'lbs.', 'lbs'], grams: 453.592 },
    { names: ['gram', 'grams', 'g.', 'g', 'gs.', 'gs'], grams: 1 },
    {
        names: [
            'kilogram',
            'kilo gram',
            'kilograms',
            'kilo grams',
            'kg.',
            'kg',
            'kgs.',
            'kgs',
        ],
        grams: 1000,
    },
    { names: ['liter', 'liters', 'l.', 'l', 'ls.', 'ls'], grams: 1000 },
];
